import { render, staticRenderFns } from "./CollaborationAccountList.vue?vue&type=template&id=73628b85&scoped=true&"
import script from "./CollaborationAccountList.vue?vue&type=script&lang=js&"
export * from "./CollaborationAccountList.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationAccountList.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./CollaborationAccountList.vue?vue&type=style&index=1&id=73628b85&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73628b85",
  null
  
)

export default component.exports